import { ArrowUp } from "lucide-react";
import { useContent } from "@/i18n";
import { Shape3D } from "@/components/Objects3D";

export const Footer = () => {
  const { c, ui } = useContent();
  const profile = c.profile;
  return (
    <footer className="relative overflow-hidden bg-choco text-cream" data-testid="footer">
      <Shape3D shape="star" blue size={52} className="absolute right-[10%] top-10 opacity-90" />
      <Shape3D shape="cloud" size={60} className="absolute left-[6%] bottom-12 opacity-60" duration={8} />
      <div className="max-w-7xl mx-auto px-6 py-16 relative">
        <div className="flex flex-wrap items-end justify-between gap-8">
          <div>
            <p className="font-serif text-4xl md:text-5xl tracking-tight">
              Sahithi <span className="italic text-cobalt">Rasakonda</span>
            </p>
            <p className="mt-4 text-xs tracking-[0.25em] uppercase text-cream/50">{ui.footer.tagline}</p>
          </div>
          <a
            href="#top"
            data-testid="back-to-top-button"
            className="group inline-flex items-center gap-3 rounded-full border border-cream/30 px-6 py-3 text-xs tracking-[0.2em] uppercase font-bold hover:bg-cobalt hover:border-cobalt transition-colors duration-400"
          >
            {ui.footer.backToTop}
            <ArrowUp size={14} className="transition-transform duration-300 group-hover:-translate-y-0.5" />
          </a>
        </div>
        <div className="mt-14 pt-8 border-t border-cream/15 flex flex-wrap items-center justify-between gap-4 text-xs text-cream/40">
          <p>{ui.footer.copyright}</p>
          <p className="font-serif italic text-cobalt">{ui.footer.quote}</p>
        </div>
      </div>
    </footer>
  );
};
